<template>
    <div class="max-w-md bg-white rounded-md shadow overflow-hidden">
        <form @submit.prevent="store">
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <div class="pb-8 pr-6 w-full">
                    <label class="block text-sm font-medium text-gray-700 mb-1">
                        Бонус при поповненні балансу (%)
                    </label>
                    <div class="flex items-center gap-2">
                        <input
                            v-model="form.topup_bonus_percent"
                            type="number"
                            min="0"
                            max="100"
                            step="0.01"
                            class="mt-1 block w-full border-gray-300 rounded-md shadow-sm text-sm p-2"
                        />
                        <span class="text-gray-500 text-sm">%</span>
                    </div>
                    <p class="text-xs text-gray-400 mt-1">
                        Встановіть 0, щоб вимкнути бонус. Наприклад: 10 = +10% до суми поповнення.
                    </p>
                    <div v-if="form.errors.topup_bonus_percent" class="form-error">
                        {{ form.errors.topup_bonus_percent }}
                    </div>
                </div>
            </div>
            <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                    Зберегти
                </loading-button>
            </div>
        </form>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: { LoadingButton },
    layout: Layout,
    props: {
        config: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                topup_bonus_percent: this.config?.topup_bonus_percent ?? 0,
            }),
        }
    },
    methods: {
        store() {
            this.form.post(this.$route('balance-config.store'))
        },
    },
}
</script>
